import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './PaymentTransfer.css';

const server_ip = process.env.REACT_APP_SERVER_IP;

export const PaymentTransfer = () => {
  function getCookie(name) {
    let cookieArray = document.cookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      let cookiePair = cookieArray[i].trim().split('=');
      if (cookiePair[0] === name) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }
  
  const location = useLocation();
  const navigate = useNavigate();
  
  // state로 전달받은 데이터 추출
  const { 
    tourName = '', 
    reservationDate = null,
    reservationTime = '',
    amount = 0,
    totalPrice = 0,
    userName = ''
  } = location.state || {};

  const BANK_INFO = {
    bankName: '신한은행',
    accountNumber: '110-123-456789',
    accountHolder: '(주)유어네스트'
  };

  const handleCopyAccount = () => {
    navigator.clipboard.writeText(BANK_INFO.accountNumber);
    alert('계좌번호가 복사되었습니다.');
  };

  const goToMyPage = () => {
    navigate('/customer-mypage');
  };

  return (
    <div className="payment-transfer">
      <div className="payment-transfer__title">계좌이체 안내</div>
      
      <div className="payment-transfer__info-box">
        <div className="payment-transfer__section">
          <div className="payment-transfer__subtitle">입금 정보</div>
          <div className="payment-transfer__row">
            <div className="payment-transfer__label">예약자명</div>
            <div className="payment-transfer__value">{userName}</div>
          </div>
          <div className="payment-transfer__row">
            <div className="payment-transfer__label">투어명</div>
            <div className="payment-transfer__value">{tourName}</div>
          </div>
          <div className="payment-transfer__row">
            <div className="payment-transfer__label">예약일시</div>
            <div className="payment-transfer__value">
              {reservationDate ? `${new Date(reservationDate).toLocaleDateString()} ${reservationTime}` : '-'}
            </div>
          </div>
          <div className="payment-transfer__row">
            <div className="payment-transfer__label">인원</div>
            <div className="payment-transfer__value">{amount}인</div>
          </div>
          <div className="payment-transfer__row">
            <div className="payment-transfer__label">입금금액</div>
            <div className="payment-transfer__value">{totalPrice.toLocaleString()}원</div>
          </div>
        </div>

        <div className="payment-transfer__section">
          <div className="payment-transfer__subtitle">입금 계좌</div>
          <div className="payment-transfer__account-info">
            <div className="payment-transfer__row">
              <div className="payment-transfer__label">은행</div>
              <div className="payment-transfer__value">{BANK_INFO.bankName}</div>
            </div>
            <div className="payment-transfer__row">
              <div className="payment-transfer__label">계좌번호</div>
              <div className="payment-transfer__value-with-button">
                <span>{BANK_INFO.accountNumber}</span>
                <button onClick={handleCopyAccount}>복사</button>
              </div>
            </div>
            <div className="payment-transfer__row">
              <div className="payment-transfer__label">예금주</div>
              <div className="payment-transfer__value">{BANK_INFO.accountHolder}</div>
            </div>
          </div>
        </div>

        <div className="payment-transfer__notice">
          <p>※ 주의사항</p>
          <ul>
            <li>입금자명은 예약자명과 동일해야 합니다.</li>
            <li>24시간 이내 미입금 시 예약이 자동 취소됩니다.</li>
            <li>입금 확인 후 예약이 확정되며, 마이페이지에서 확인 가능합니다.</li>
          </ul>
        </div>
      </div>

      <button className="payment-transfer__confirm-button" onClick={goToMyPage}>
        마이페이지로 이동
      </button>
    </div>
  );
};